<template>
  <div class="content">
    <scroll v-if="carList.length > 0" class="list orderList" :data="carList" :pulldown="true" @onPullDownRefresh="onPullDownRefresh" :pullup="true" @onPullUp="lower">
      <div>
        <div class="itemBlock" v-for="(item,index) in carList" :key="index">
          <div class="carBlock" v-if="item.Status == 4">
            <div class="top">
              <div class="left">
                <div class="carinfo">
                <span class="carname">{{item.CarClass}}</span>
                <span>{{item.CarNumber}}</span>
                </div>
              </div>
              <div class="right">
                <span class="carStatus">{{item.StatusText}}</span>
              </div>
            </div>
            <div class="bottom">
              <span class="remark">备注:{{item.Remark||'无'}}</span>
              <p class="btn" @click="goAddcar(item)">重新提交</p>
            </div>
          </div>
          <div class="carBlock" v-else>
            <div class="top">
              <div class="left">
                <div class="carinfo">
                <span class="carname">{{item.CarClass}}</span>
                <span>{{item.CarNumber}}</span>
                </div>
              </div>
              <div class="right">
                <span class="carStatus">{{item.StatusText}}</span>
              </div>
            </div>
            <div class="bottom" v-if="item.Remark" @click="goAddcar(item)">
              <span class="remark">备注:{{item.Remark}}</span><p></p>
            </div>
          </div>
        </div>
        <div class="lowerdata" v-if=" pageIndex == total_page && carList.length > 2">没有更多了~</div>
      </div>
    </scroll>
    <div class="nodata" v-else>您还没有车辆，立即添加赚收益~</div>
  </div>
</template>

<script>
import { gettotalAccount, getCarOnwerCars } from "@/utils/api";
import scroll from "@/components/scroll.vue";
export default {
  name: "index",
  data(){
    return {
      totalAccount: 0,
      carNum: 0,
      pageIndex: 1,
      pagesize: 10,
      total_page: 0,
      defaultCarImg: "/static/images/index/car.png",
      carList: []
    };
  },
  components: { scroll },
  created(){
    localStorage.removeItem('userInfo');
    localStorage.removeItem('cityInfo');
    localStorage.removeItem('addressInfo');
    localStorage.removeItem('memberInfo');
  },
  mounted(){
    this.initCar();
  },
  methods: {
    async initCar() {
      let res = await getCarOnwerCars({
        data: {
          page: this.pageIndex,
          pagesize: this.pagesize
        },
        isLoading: true,
        loadContent: "加载中..."
      });
      if (res.Code == 100) {
        let dataList = res.Data.Rows || [];
        for (let i = 0; i < dataList.length; i++) {
          if( dataList[i].Remark ){
            dataList[i].Remark = dataList[i].Remark.replace(/\s+/g,"");
            if( dataList[i].CarID>0 ){
              _carNum ++;
            }
          }
          switch (dataList[i].Status) {
            case 1:
              res.Data.Rows[i].StatusText = "待审核";
              break;
            // case 3:
            //   res.Data.Rows[i].StatusText = "待上线";
            //   break;
            case 4:
              res.Data.Rows[i].StatusText = "已拒绝";
              break;
            // case 5:
            //   res.Data.Rows[i].StatusText = "待租";
            //   if( res.Data.Rows[i].AutoStatusName!='' ){
            //     res.Data.Rows[i].StatusText = res.Data.Rows[i].AutoStatusName;
            //   }
            //   break;
            // case 6:
            //   res.Data.Rows[i].StatusText = "已下线";
            //   break;
            default:
              res.Data.Rows[i].StatusText = "审核通过";
              break;
          }
          if(dataList[i].Status!=5&&dataList[i].Status!=6){
            this.carList.push(dataList[i]);
          }
        }
        this.carNum = res.Data.Total;
        this.total_page = Math.ceil(this.carNum / this.pagesize);

      }
    },
    onPullDownRefresh() {
      this.pageIndex = 1;
      this.carList = [];
      this.initCar();

    },
    //上拉加载
    lower() {
      console.log(11);
      if(this.pageIndex < this.total_page){
        this.pageIndex += 1;
        this.initCar();
      }
    },
    goIncomedetail() {
      this.$router.push({ path: "/profitDetail" });
    },
    goAddcar(vo) {
      let userInfo = {};
      if (vo) {
        userInfo = vo;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      console.log(userInfo);
      this.$router.push({ path: "/addCar" });
    },
    goInvite(type) {
      this.$router.push({ path: "/invite", query: { type: type } });
    }
  }
};
</script>
<style scoped lang="scss" type="text/scss">
  .list {
      width: 100%;
      height: 90vh;
      overflow: hidden;
      padding: 10px;
      box-sizing: border-box;
  }
  .content{
    position: fixed;
    width:100%;
    height: 100vh;
    padding: 20px 32px 0 20px;
    box-sizing: border-box;
    background: #fff;
        .carBlock {
          padding: 25px 23px;
          margin-bottom: 20px;
          box-sizing: border-box;
          box-shadow: 0 0 6px #ccc;
          -webkit-box-shadow: 0 0 6px #ccc;
          .top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
              display: flex;
              .carImg {
                width: 185px;
                height: 104px;
              }
              .carinfo {
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                color: #9f9f9f;
                .carname {
                  margin-bottom: 10px;
                  font-size: 34px;
                  font-weight: bold;
                  color: #000;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 300px;
                  overflow: hidden;
                }
              }
            }
            .right {
              display: flex;
              flex-direction: column;
              text-align: right;
              color: #9f9f9f;
              height: 90px;
              .carStatus {
                margin-bottom: 10px;
                color: #ff572c;
                font-weight: bold;
              }
            }
          }
          .bottom {
            display: flex;
            margin-top: 10px;
            margin-left: 10px;
            color: #9f9f9f;
            border-top:1px solid #ededed;
            padding-top:25px;
            .remark {
              width: 100%;
            }
            .btn{
              width:164px;
              height:50px;
              background:rgba(2,127,255,1);
              box-shadow:0px 0px 6px rgba(0,0,0,0.16);
              border-radius:25px;
              line-height: 50px;
              text-align: center;
              font-size:22px;
              color:#fff;
            }

          }
        }
        .lowerdata {
          text-align: center;
          color: #9f9f9f;
        }

    .nodata {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        margin-top: 200px;
        box-sizing: border-box;
        color: #9f9f9f;
      }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/applylist.vue